/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pclients': {
    width: 22,
    height: 17,
    viewBox: '0 0 22 17',
    data: '<path pid="0" d="M10.786 10.65l2.367-1.05a.815.815 0 0 1 .799.097 2.632 2.632 0 0 0 3.14 0 .812.812 0 0 1 .798-.095l2.055.87c.229.1.403.301.463.542l.762 2.948a.81.81 0 0 1-.785 1.015h-6.392l.193.75a.886.886 0 0 1-.858 1.108H1.256a.886.886 0 0 1-.858-1.107l.945-3.66a.883.883 0 0 1 .513-.595l2.543-1.079a.89.89 0 0 1 .873.105c1.2.891 2.84.891 4.039 0a.89.89 0 0 1 .875-.104l.6.254zm1.262.534l.681.289a.888.888 0 0 1 .512.594l.493 1.91h6.407l-.678-2.622-1.866-.791a3.631 3.631 0 0 1-4.151 0l-1.398.62zm.81 3.4l-.571-2.213-2.433-1.03a4.384 4.384 0 0 1-5.125 0l-2.432 1.03-.894 3.464H13.18l-.313-1.214a.496.496 0 0 1-.01-.037zm-1.19-9.538a4.377 4.377 0 1 1-8.753 0 4.377 4.377 0 1 1 8.754 0zm-1 0a3.377 3.377 0 1 0-6.753-.002 3.377 3.377 0 0 0 6.754.002zm8.477.335a3.624 3.624 0 1 1-7.249 0 3.624 3.624 0 0 1 7.249 0zm-1 0a2.624 2.624 0 1 0-5.249 0 2.624 2.624 0 0 0 5.249 0z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/pclients.js